import type { ComposeBodyDocument } from './types';
import { htmlHasSlateRichFormatting } from './classifyBodyKind';
import {
  resolveUserBodyForPersistence,
  stripLockedComposeBlocksFromUserBody,
  stripTrailingSignatureBlocks,
  trimTrailingEmptyComposeParagraphs,
} from './editorHtml';
import { normalizeQuotedBlock } from './quotedBlockNormalize';

/** Full compose document for library template save (keeps signature + quoted forward/reply). */
export function buildComposeDocForTemplatePersistence({
  doc,
  liveEditorHtml,
}: {
  doc: ComposeBodyDocument;
  liveEditorHtml?: string | null;
}): ComposeBodyDocument {
  const userBody = stripTrailingSignatureBlocks(
    stripLockedComposeBlocksFromUserBody(
      trimTrailingEmptyComposeParagraphs(
        resolveUserBodyForPersistence(doc.userBody, liveEditorHtml),
        { maxTrailingEmpty: 0 },
      ),
    ),
  );
  const bodyKind =
    doc.quoted || htmlHasSlateRichFormatting(userBody) ? 'rich' : doc.bodyKind;
  return {
    ...doc,
    bodyKind,
    userBody,
    quoted: doc.quoted ? normalizeQuotedBlock(doc.quoted) : undefined,
  };
}
